import { Injectable } from '@angular/core';
import { BaseDataService } from '../classes/base-data-service';
import { Http, ResponseContentType } from '@angular/http';
import { StoreService } from './store.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class LoyaltyCardService extends BaseDataService {
  constructor(
		http: Http,
		storeService: StoreService,
		authenticationService:AuthenticationService,
	) {
		super(http, 'LOLoyaltyCard', storeService, authenticationService);
  }

  CheckLoyaltyCardLimit(LoyaltyCardNumber, eventId) {
    this.setCustomEndpoint('CheckLoyaltyCardLimit');

    let json = {
      'LoyaltyCardNumber': LoyaltyCardNumber,
      'EventId': eventId
    }

    return this.postWithData(json, {
			responseType: ResponseContentType.Json,
		});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalty-card.service.ts